import React, { Component } from 'react'

import { loadScript } from '../../utils/common'

class ApplySurveyForm extends Component {

  constructor(props) {
    super(props)
    this.state = { widget: null }
  }

  componentDidMount() {
    const isClient = typeof window !== 'undefined'
    if (isClient) {
      this.loadWidget()
    }
  }

  loadWidget = () => {
    if (window.document.getElementById('choicely-widget')) {
      return this.initializeWidget()
    }

    if (typeof window.webpackJsonp === 'function') {
      window.webpackJsonp = null
    }

    loadScript(
      'choicely-widget',
      `https://cdn.choicely.com/widget.js?t=${Date.now()}`,
      () => this.initializeWidget()
    )
  }

  initializeWidget() {
    if (window.ChoicelyWidget) {
      const params = {
        "bid": "choicely-widget-survey-a036758a7586",
        "sk": "ag1zfmxvdmVudGVkYXBwciULEgVCcmFuZBiAgICXx821CQwLEgZTdXJ2ZXkYgICA57CW_goM",
        "auth": "facebook,google,email", "v": "survey"
      }
      this.setState({ widget: window.ChoicelyWidget.i(params) })
    }
  }

  render() {
    return (
      <div id="choicely-widget-survey-a036758a7586" style={{ maxWidth: '100%' }} />
    )
  }
}

export default ApplySurveyForm



// WEBPACK FOOTER //
// ./src/components/apply-survey-form/apply-survey-form.js